import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { UniversalTime } from "@biteinc/helpers-universal";
//#region src/utils/open_hours_timetable_utils.ts
var open_hours_timetable_utils_exports = /* @__PURE__ */ __exportAll({ isActiveAt: () => isActiveAt });
function isActiveAt(data, time, timezone) {
	const weekTimestamp = UniversalTime.weekTimestamp(time, timezone);
	const weekday = UniversalTime.getDayFromWeekTimestamp(weekTimestamp);
	const weekdaySchedules = data.daySchedules.find((daySchedule) => {
		return daySchedule.weekday === weekday;
	});
	if (!weekdaySchedules) return false;
	const dayTimestamp = UniversalTime.getDayTimestampFromWeekTimestamp(weekTimestamp);
	return weekdaySchedules.schedules.some((schedule) => {
		return UniversalTime.scheduleIsActiveAt(schedule, dayTimestamp);
	});
}
//#endregion
export { isActiveAt, open_hours_timetable_utils_exports };

//# sourceMappingURL=open_hours_timetable_utils.js.map